import React from "react";
import "./story-card19.m.css";
import { Link } from "@quintype/components";
import StoryDate from "../../atoms/story-date";
import Headline from "../../atoms/headline";

function StoryCard19({ story }) {
  const { url, headline, id } = story;
  return (
    <Link href={url}>
      <div styleName="wrapper" id="story-card-19">
        <Headline text={headline} headerType={2} headerLevel={2} story={story} id={id} lineClamp={3} />
        <p styleName="date">
          <StoryDate story={story} />
        </p>
      </div>
    </Link>
  );
}

export default StoryCard19;
